/**
 * Path helpers shared by the analytics layer.
 * Kept dependency-free so it can run in SSR and the client without pulling posthog-js.
 */

export function isAdminPath(pathname: string | undefined | null): boolean {
  if (!pathname) return false;
  if (pathname === "/admin") return true;
  if (pathname.startsWith("/admin/")) return true;
  return false;
}